import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { MascotDoodle } from "@/components/brand/MascotDoodle";
import { Mascot } from "@/components/brand/Mascot";
import { Reveal } from "@/components/Reveal";
import { ClosedBanner, VotingCountdown, WinnerReveal } from "@/components/sotm/SotmBits";
import { getSotmGallery, monthLabel } from "@/lib/api";

export const SotmSpotlight = () => {
  const [data, setData] = useState(null);
  useEffect(() => { getSotmGallery().then(setData).catch(() => {}); }, []);
  const w = data?.current_winner;
  if (data?.month_winner) {
    return (
      <section className="border-y border-ink bg-pink" aria-label="Sus of the Month winner announced" data-testid="home-sotm-spotlight">
        <div className="mx-auto max-w-[1440px] px-5 py-20 sm:px-10 lg:py-28"><WinnerReveal w={data.month_winner} testid="home-sotm-reveal" compact /></div>
      </section>
    );
  }
  return (
    <section className="border-y border-ink bg-pink" aria-labelledby="sotm-spot-title" data-testid="home-sotm-spotlight">
      <div className="mx-auto grid max-w-[1440px] items-center gap-12 px-5 py-24 sm:px-10 lg:grid-cols-12 lg:py-32">
        <Reveal className="lg:col-span-6">
          <p className="label flex items-center gap-3 font-bold"><Mascot size={30} fill="#7FD3FF" label="" /> Sus of the Month · Ages 13–19</p>
          <h2 id="sotm-spot-title" className="display mt-5 text-[clamp(3.25rem,7vw,6.5rem)]">Sus of the <span className="hl hl-sky hl-thick">month</span></h2>
          {data && !data.voting_open ? (
            <div className="mt-8"><ClosedBanner rows={data.leaderboard} testid="home-sotm-closed" /></div>
          ) : (
            <>
              {w ? (
                <p className="mt-6 max-w-md text-[15px] leading-relaxed text-ink" data-testid="home-sotm-winner">{monthLabel(w.month)} winner: <b>{w.design_title}</b> by {w.first_name}, {w.age}, from {w.city}. Local teens design it, the community votes, we print it.</p>
              ) : (
                <p className="mt-6 max-w-md text-[15px] leading-relaxed text-ink" data-testid="home-sotm-open">Submissions open, get your design in the lineup. Local teens design it, the community votes, we print it.</p>
              )}
              {data && <div className="mt-8"><VotingCountdown closesAt={data.voting_closes_at} testid="home-sotm-countdown" /></div>}
            </>
          )}
          <div className="mt-8 flex flex-wrap items-center gap-6">
            <Link to="/sus-of-the-month/submit" className="btn btn-lime" data-testid="home-sotm-submit">Submit a design <ArrowRight size={16} /></Link>
            <Link to="/sus-of-the-month" className="link-u" data-testid="home-sotm-vote">{data && !data.voting_open ? "See the lineup" : "Vote this month"} <ArrowRight size={14} /></Link>
          </div>
        </Reveal>
        <Reveal delay={120} className="relative lg:col-span-5 lg:col-start-8">
          {w ? (
            <Link to={`/sus-of-the-month/${w.slug}`} className="group block" data-testid="home-sotm-winner-link">
              <div className="aspect-square overflow-hidden rounded-[24px] border-[1.5px] border-ink bg-cloud"><img src={w.design_url} alt={`${w.design_title} by ${w.first_name}`} loading="lazy" className="h-full w-full object-cover mix-blend-multiply transition-transform duration-700 group-hover:scale-[1.03]" /></div>
              <span className="sticker absolute -left-3 -top-3 bg-lime !text-xs">{monthLabel(w.month)} winner</span>
            </Link>
          ) : <MascotDoodle variant="crown" size={320} bg="#7FD3FF" className="mx-auto w-[70%]" />}
        </Reveal>
      </div>
    </section>
  );
};
